'use strict';

var registration = require('../registration'),
	linchpin = require('int_googletagmanager/linchpin/error'),
	reCaptcha = require('int_recaptcha/recaptcha');


var isFormSubmitted = false;

exports.init = function () {
	var $vipmeSignupForm = $('form.vipme-signup');

	if ($('#RegistrationForm').length > 0) {
		registration.init();
	}

	// GTM Linchpin analytics
	if (SitePreferences.GTM_ENABLED) {
		$('[id$="_login"] input.required').on('focusout', function () {
			linchpin.pushSingleErrorObject($(this));
		});
	}

	var $vipmeCode = $vipmeSignupForm.find('input.vipmecode');
	var $vipmeCardStatus = $vipmeSignupForm.find('[name*=vipme-card-status]');
	$vipmeCardStatus.on('click', function () {
		if ($(this).val() === 'cardpresent') {
			$vipmeCode.parents('.form-row').addClass('active');
			$vipmeCode.attr('required', 'required').addClass('required');
			if ($vipmeCode.hasClass('error')) {
				$vipmeSignupForm.validate().element($vipmeCode);
			}
		} else {
			$vipmeCode.parents('.form-row').removeClass('active');
			$vipmeCode.removeAttr('required').removeClass('required');
			$vipmeSignupForm.validate().element($vipmeCode);
		}
	});

	//validation for barcode and date inputs
	if (SitePreferences.GTM_ENABLED) {
		$vipmeSignupForm.find('.input-text').on('change', function () {
			linchpin.pushSingleErrorObject($(this));
		});
	}

	$vipmeSignupForm.on('submit', function (event) {
		var $generateCodeField = $('input.generate-vipmecode-hidden');
		$generateCodeField.val(true);
		if ($('[id*=cardpresent]:checked').length) {
			$generateCodeField.val(false);
		} else {
			$vipmeCode.val('');
		}

		var $form = $('.vipme-signup');
		if (!$form.valid() || !birthdayIsValid()) {
			reCaptcha.resetRecaptchaForms();
			return false;
		}

		if (isFormSubmitted) {
			event.preventDefault();
			return false;
		}
		isFormSubmitted = true;
	});

	reCaptcha.initRecaptchaOnForm('form.vipme-signup', function() {
		$vipmeSignupForm.trigger('submit');
	});

	var $welcomeDiscount = $('.welcome-offer');
	if ($welcomeDiscount.length) {
		var $copyButton = $welcomeDiscount.find('.copy-button');
		var welcomeCode = $welcomeDiscount.find('.welcome-code').length ? $welcomeDiscount.find('.welcome-code').text() : '';

		$copyButton.on('click', function () {
			window.navigator.clipboard.writeText(welcomeCode);
		});
	}
};

// process chosen birthday, if the user is younger that 18, show restriction note
function birthdayIsValid() {
	var $vipmeSignupForm = $('form.vipme-signup');
	var $birthday = $vipmeSignupForm.find("[id$='birthday']");
	if ($birthday.length && $birthday.val()) {
		var dateValue = $birthday.val().split('/');
		var dayValue = dateValue[0];
		var monthValue = dateValue[1] - 1;
		var yearValue = dateValue[2];
		var currentDate = new Date();
		var adultAgeDate = new Date(yearValue, monthValue, dayValue);
		adultAgeDate.setFullYear(adultAgeDate.getFullYear() + 18);

		if (currentDate < adultAgeDate) {
			$('.age-restriction-note').addClass('active');
			$birthday.addClass('error');

			reCaptcha.resetRecaptchaForms();
			return false;
		}
		$('.age-restriction-note').removeClass('active');
		$birthday.removeClass('error');
		return true;
	}
	return true;
}
